import { theme } from "../../../../lib/styles/theme";
export default function CellFavorite(params) {
  var _context$favoriteData, _context$favoriteData2, _favorite$getShouldHi;
  const {
    favorite,
    column,
    context
  } = params;
  if (!favorite) return null;
  const rowId = params.node.id;
  if (!rowId) return null;
  const colId = (column === null || column === void 0 ? void 0 : column.colId) || '';
  let isDisabled = false;
  if (favorite.isDisabled) {
    if (typeof favorite.isDisabled === 'function') isDisabled = favorite.isDisabled(colId, rowId);else isDisabled = favorite.isDisabled;
  }
  let isFavorite = false;
  if (context !== null && context !== void 0 && (_context$favoriteData = context.favoriteData) !== null && _context$favoriteData !== void 0 && (_context$favoriteData2 = _context$favoriteData[colId]) !== null && _context$favoriteData2 !== void 0 && _context$favoriteData2.rows) {
    isFavorite = favorite.getIsRowFavorite(colId, rowId);
  }
  const tableId = (context === null || context === void 0 ? void 0 : context.tableId) || '';
  const svg = getSvg(favorite.displayAsFollow, isFavorite, tableId, colId, rowId);
  const cell = document.createElement('div');
  cell.classList.add('w5-cell-favorite');
  const shouldHide = (favorite === null || favorite === void 0 ? void 0 : (_favorite$getShouldHi = favorite.getShouldHide) === null || _favorite$getShouldHi === void 0 ? void 0 : _favorite$getShouldHi.call(favorite, params.data)) || false;
  if (shouldHide) {
    cell.classList.add('w5-cell-favorite-none');
    return cell;
  }
  if (isDisabled) cell.classList.add('w5-cell-favorite--disabled');
  if (!params.favorite.isAlwaysVisible) {
    if (isFavorite) {
      cell.classList.remove('w5-cell-favorite--hidden');
      cell.classList.add('w5-cell-favorite--visible');
    } else {
      cell.classList.remove('w5-cell-favorite--visible');
      cell.classList.add('w5-cell-favorite--hidden');
    }
  }
  if (favorite.onClick) {
    svg.addEventListener('click', handleOnChange(cell, svg, rowId, isFavorite, isDisabled, colId, favorite.onClick, context, params.rowIndex, params.data, params.favorite.isAlwaysVisible, tableId, favorite.displayAsFollow));
  }
  cell.appendChild(svg);
  return cell;
}
const getSvg = (displayAsFollow, isFavorite, tableId, colId, rowId) => {
  const svgStar = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 24 24">
                        <defs>
                            <path id="favorite-table-${tableId}-col-${colId}-row-${rowId}" d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/>
                        </defs>
                        <use fill="${theme.colors.semantic.focus500}" xlink:href="#favorite-table-${tableId}-col-${colId}-row-${rowId}" fill-rule="evenodd"/>
                    </svg>`;
  const svgStarOutline = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 24 24">
                                <defs>
                                    <path id="non-favorite-table-${tableId}-col-${colId}-row-${rowId}" d="M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4l-3.76 2.27 1-4.28-3.32-2.88 4.38-.38L12 6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z"/>
                                </defs>
                                <use fill="${theme.colors.actionMinor[400]}" xlink:href="#non-favorite-table-${tableId}-col-${colId}-row-${rowId}" fill-rule="evenodd"/>
                            </svg>`;
  const flag = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <path id="favorite-table-${tableId}-col-${colId}-row-${rowId}" fill="${theme.colors.actionMajor[500]}" fill-rule="evenodd" d="M14.4 6 14 4H5v17h2v-7h5.6l.4 2h7V6h-5.6Z" clip-rule="evenodd"/>
                </svg>`;
  const flagOutline = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                            <path id="non-favorite-table-${tableId}-col-${colId}-row-${rowId}" fill="#7D8A96" fill-rule="evenodd" d="m12.36 6 .4 2H18v6h-3.36l-.4-2H7V6h5.36ZM14 4H5v17h2v-7h5.6l.4 2h7V6h-5.6" clip-rule="evenodd"/>
                        </svg>`;
  const svgContainer = document.createElement('div');
  svgContainer.classList.add('w5-cell-favorite__svg-container');
  if (isFavorite) {
    if (displayAsFollow) {
      svgContainer.innerHTML = flag;
    } else svgContainer.innerHTML = svgStar;
  } else {
    if (displayAsFollow) {
      svgContainer.innerHTML = flagOutline;
    } else svgContainer.innerHTML = svgStarOutline;
  }
  return svgContainer;
};
const handleOnChange = (cell, svg, rowId, value, isDisabled, colId, onClick, context, rowIndex, data, isAlwaysVisible, tableId, displayAsFollow) => event => {
  event.preventDefault();
  event.stopPropagation();
  if (isDisabled) return;
  value = !value;
  svg.remove();
  const newSvg = getSvg(displayAsFollow, value, tableId, colId, rowId);
  newSvg.addEventListener('click', handleOnChange(cell, newSvg, rowId, value, isDisabled, colId, onClick, context, rowIndex, data, isAlwaysVisible, tableId, displayAsFollow));
  if (!isAlwaysVisible) {
    if (value) {
      cell.classList.remove('w5-cell-favorite--hidden');
      cell.classList.add('w5-cell-favorite--visible');
    } else {
      cell.classList.remove('w5-cell-favorite--visible');
      cell.classList.add('w5-cell-favorite--hidden');
    }
  }
  cell.appendChild(newSvg);
  onClick({
    id: rowId,
    colId,
    boolean: value,
    context,
    rowIndex,
    data
  });
};